import type { TRuleWithTheme } from '@ackee/fela';

export const post: TRuleWithTheme = () => ({});

export const posts: TRuleWithTheme = () => ({
    display: 'grid',
    gridTemplateColumns: '1fr',

    marginTop: '4.475rem',

    tablet: {
        gap: '2rem',
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
});
